import { SubTitleBtnArea } from 'components/organism/SubTitleBtnArea';
import SubTitleBox from 'components/molecule/SubTitleBox';
import { GContentGrid } from 'components/layouts/GContentGrid';
import { AgGridReact } from 'ag-grid-react';
import { RefObject, useCallback, useEffect, useRef, useState } from 'react';
import { useColumnDefsForHistoryList } from './hooks/useMemberHistoryList';
import { useTranslation } from 'react-i18next';
import EmptyState from 'components/atom/emptyState';
import { GPagination, PaginationRef } from 'components/layouts/GPagination';
import { ReqMemberVO, RespMemberVO } from './MemberHistoryPage';

interface Props {
  searchParams: ReqMemberVO;
  setSearchParams: (param: ReqMemberVO) => void;
  search: (isPage: boolean, condition: ReqMemberVO) => void;
  paginationRef: RefObject<PaginationRef>;
  memberList: RespMemberVO[];
  setMemberList: (param: RespMemberVO[]) => void;
  pageNo: number;
  setPageNo: (param: number) => void;
  totalCount: number;
  pageSizeList: any;
}

const MemberListPage = ({
  paginationRef,
  memberList,
  setMemberList,
  searchParams,
  setSearchParams,
  pageNo,
  setPageNo,
  search,
  totalCount,
  pageSizeList,
}: Props) => {
  const { t } = useTranslation();

  const [pageSize, setPageSize] = useState<number>(30);

  const gridApiRef = useRef<any>(null);
  const { defaultColDef, colDefs } = useColumnDefsForHistoryList();

  const handlePageSize = (value: number) => {
    paginationRef.current?.setPageSize(value);
    setPageSize(value);
    setPageNo(1);
    const condition = {
      ...searchParams,
      start: '0',
      pageSize: String(value),
    };
    setSearchParams({ ...condition });
    search(true, { ...condition });
  };

  const handlePageNoClick = (pageNo: number) => {
    const condition = {
      ...searchParams,
      start: String((pageNo - 1) * pageSize),
    };
    setSearchParams({ ...condition });
    setPageNo(pageNo);
    search(true, { ...condition });
  };

  return (
    <>
      <SubTitleBtnArea>
        <SubTitleBox
          content={'회원 정보 이력 목록'}
          showSubTitle={true}
          isVisibleComment={false}
          isVisibleInfo={false}
          isVisbleSum={true}
          isVisbleSelect={true}
          commentCount={totalCount}
          selectOption={pageSizeList}
          defaultOption={'1'}
          onChange={handlePageSize}
        />
      </SubTitleBtnArea>
      {/* style에 flex: 1 삭제하고  높이 지정하면 특정 높이로 수정은 가능함 */}
      <GContentGrid
        type="none"
        className="ag-theme-alpine"
        style={{ marginBottom: '8px', height: 'calc(100vh - 425px)' }}
        isSortable={false}
        isPagination={true}
      >
        <AgGridReact
          defaultColDef={defaultColDef}
          columnDefs={colDefs}
          rowData={memberList}
          rowSelection={'single'}
          enableCellTextSelection
          onGridReady={(params) => (gridApiRef.current = params.api)}
          tooltipShowDelay={0}
          noRowsOverlayComponent={EmptyState}
          noRowsOverlayComponentParams={{ type: 'grid' }}
        />
        {memberList && memberList.length !== 0 && (
          <GPagination
            ref={paginationRef}
            totalCount={totalCount}
            defaultPageNo={pageNo}
            defaultPageSize={pageSize}
            onChangePageSize={handlePageSize}
            onClickPageNo={handlePageNoClick}
          />
        )}
      </GContentGrid>
    </>
  );
};

export default MemberListPage;
